import React, { useState, useEffect, useRef, useMemo } from "react";
import BulkRequestZipDocumentTable from "../../../../../bulk/request/zip/document/table";
import { getByIds as getAbstractDocumentByIds } from "../../../../document/axios";
import { create } from "../document/axios";
import { fetchCustomFieldValue } from "../../../../../helper/custom_field/helper"

const AbstractBulkRequestZipDocumentForm = props => {
  const { documentTypes, aasmStates } = props?.filters;
  const { currentEntityType, currentUser } = props;
  const [bulkRequest, setBulkRequest] = useState(props?.bulkRequest);

  const dataTableDefaultColums = [
    {
      field: "entity.identifier",
      header: I18n.t("activerecord.attributes.abstract/entity.identifier"),
      filter: {
        enabled: true,
        placeholder: `Ingrese el identificador del ${I18n.t(
          currentEntityType.singular_name
        )}`,
        filterrific: {
          search: "search_query"
        }
      },
    },
    {
      field: "document_type.name",
      header: I18n.t("activerecord.attributes.laboral/hiring_document.document_type"),
      filter: {
        enabled: true,
        placeholder: `Seleccione un tipo de documento`,
        inputType: 'simple_select',
        options: _.map(documentTypes, document_type => ({
          value: document_type.id,
          label: document_type.name,
        })),
        filterrific: {
          search: "by_document_type"
        }
      },
    },
    {
      field: "created_at_to_s",
      header: I18n.t("activerecord.attributes.laboral/hiring_document.created_at"),
      filter: {
        enabled: true,
        placeholder: `Ingrese la ${I18n.t(
          "activerecord.attributes.laboral/hiring_document.created_at"
        )}`,
        filterrific: {
          search: "search_by_created_at"
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: "created_at_to_s_"
        }
      }
    },
    {
      field: "aasm_state",
      header: I18n.t("activerecord.attributes.laboral/hiring_document.aasm_state.one"),
      body: (row) => I18n.t(`activerecord.attributes.laboral/hiring_document.aasm_state.${row.aasm_state}`),
      filter: {
        enabled: true,
        placeholder: `Seleccione un estado`,
        inputType: 'simple_select',
        options: aasmStates,
        filterrific: {
          search: "by_aasm_state"
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: "aasm_state_"
        }
      }
    }
  ]

  const dataTableCustomFieldsColumns = useMemo(() => {
    return _.map(props?.customFields, function (customField) {
      return {
        field: `entity.custom_fields.${customField.code}`,
        header: _.capitalize(customField.label),
        body: (row) => {
          return fetchCustomFieldValue(customField, row.entity.custom_fields[customField.code], currentUser)
        },
        filter: {
          enabled: true,
          placeholder: `Ingrese ${_.capitalize(customField.label)}`,
          filterrific: {
            search: `search_by_key_custom_fields`,
            searchKey: customField.code
          }
        },
        configuration: {
          isCustomField: true
        }
      }
    })
  }, [props?.customFields])

  const abstractDocumentsColumns = useMemo(() => {
    let columns = _.concat(
      dataTableDefaultColums,
      dataTableCustomFieldsColumns
    )

    return _.compact(columns)
  }, [])

  const tableConfirmDocument = (documents, drawDeleteSelectedDocument) => {
    return (
      <div className="d-flex">
        <table className="table mt-2 table-responsive-md">
          <thead>
            <tr>
              <th>
                {I18n.t("activerecord.attributes.abstract/entity.identifier")}
              </th>
              <th>
                {I18n.t("activerecord.attributes.abstract/document.document_type")}
              </th>
              <th>
                {I18n.t("activerecord.attributes.abstract/document.created_at")}
              </th>
              <th>
                {I18n.t("activerecord.attributes.laboral/hiring.delete")}
              </th>
            </tr>
          </thead>
          <tbody>
            {_.map(documents, function (document, index) {
              return (
                <tr key={`tr-list-documents-${document.id}`}>
                  <td>{document.entity?.name}</td>
                  <td>{document?.document_type?.name}</td>
                  <td>{document.created_at_to_s}</td>
                  <td>{drawDeleteSelectedDocument(document)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div>
      <BulkRequestZipDocumentTable
        showBulkMyFilter={false}
        bulkRequest={bulkRequest}
        dataTableConfiguration={{
          columns: abstractDocumentsColumns
        }}
        tableConfirmDocument={tableConfirmDocument}
        configuration={{
          context: "abstract",
          defaultRequestParams: {
            current_entity_type_id: props.currentEntityType.hashid
          },
        }}
        actions={{
          indexDocumentsPath: Routes.abstract_documents_path,
          createService: create,
          getDocumentByIds: getAbstractDocumentByIds
        }}
        buttonActions={{
          show: Routes.abstract_bulk_request_zip_document_path,
          back: Routes.abstract_bulk_request_zip_documents_path({ current_entity_type_id: props?.currentEntityType?.hashid }),
        }}
      />
    </div>
  );
};

export default AbstractBulkRequestZipDocumentForm;
